import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react';
import Store, { useStore } from '../../stores/Store';
import { useNavigate } from 'react-router-dom';
import './style.scss';
import { button, textInput, View } from '../../components';
import Clients from './Clients';
import Users from './Users';
import Profile from './Profile';
import Briefs from './Briefs';
import Overview from './Overview';
import Audit from './Audit';
import Projects from './Projects';
import Professionals from './Professionals';
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`
var mobile = require('is-mobile');

const AdminDashboard = observer(() => {
    
    const store = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [PageSelected, setPageSelected] = useState('Overview');
    const [FullName, setFullName] = useState('');
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);


    useEffect(() => {
        let fullNames = store.user.firstName + ' ' + store.user.lastName;
        setFullName(fullNames);
    }, []);
    const isLongName = FullName.length > 17;
    const handleTabClick = (e) => {
        setPageSelected(e.target.id);
        forceUpdate();
    };
    // const logOutClicked = () => {
    //     store.logout();
    // };

    const logOutClicked = () => {
        setShowLogoutPopup(true);
    };

    const confirmLogout = () => {
        store.logout();
        setShowLogoutPopup(false);
    };

    const cancelLogout = () => {
        setShowLogoutPopup(false);
    };


    ///store.setLoading (false);

    if (mobile()) {
        return (
            <div>

            </div>
        );

    } else {
        return (
            <View className='CredippleDashboard'>
                <div className='dashSidebar'>
                    <div className='userProfileInfo'>
                        <div className='userProfilePictureConatiner' style={{ cursor: 'pointer' }} id='Profile' onClick={handleTabClick}>
                            <img className='profilePicture' src={UserIcon} alt='Profile Picture' />
                        </div>
                        <div className='userDetails'>
                            {isLongName ? (
                                < >
                                    <p className='userNames'>{store.user.firstName}</p>
                                    <p className='userNames'>{store.user.lastName}</p>
                                </>
                            ) : (
                                < >
                                    <p id='Profile' onClick={handleTabClick} style={{ cursor: 'pointer' }} className='userNames'>{FullName}</p>
                                    <p id='Profile' onClick={handleTabClick} style={{ cursor: 'pointer' }} className='userEmail'>{store.user.email}</p>
                                </>
                            )}

                        </div>
                    </div>
                    <hr className='hr' />
                    <div className='dashboardTabs'>
                        <p className={PageSelected === "Overview" ? 'selectedTabLabel' : 'tabLabel'} id='Overview' onClick={handleTabClick}>Overview</p>
                        <p className={PageSelected === "Audit" ? 'selectedTabLabel' : 'tabLabel'} id='Audit' onClick={handleTabClick}>Audit</p>
                        {Object.keys(store?.user).includes('permissions') && Array.isArray(store?.user?.permissions) &&
                            <>
                                {/* <p className={PageSelected === "Profile" ? 'selectedTabLabel' : 'tabLabel'} id='Profile' onClick={handleTabClick}>Profile</p> */}
                                {store.user.permissions.some(permission => permission.includes("Client")) ? <p className={PageSelected === "Clients" ? 'selectedTabLabel' : 'tabLabel'} id='Clients' onClick={handleTabClick}>Clients</p> : null}
                                {store.user.permissions.some(permission => permission.includes("User")) ? <p className={PageSelected === "Professionals" ? 'selectedTabLabel' : 'tabLabel'} id='Professionals' onClick={handleTabClick}>Professionals</p> : null}
                                {store.user.permissions.some(permission => permission.includes("Brief")) ? <p className={PageSelected === "Projects" ? 'selectedTabLabel' : 'tabLabel'} id='Projects' onClick={handleTabClick}>Projects</p> : null}
                                {store.user.permissions.some(permission => permission.includes("Brief")) ? (<p className={PageSelected === "Briefs" ? 'selectedTabLabel' : 'tabLabel'} id='Briefs' onClick={handleTabClick}>Briefs</p>) : null}
                                {store.user.permissions.some(permission => permission.includes("User")) ? (<p className={PageSelected === "Users" ? 'selectedTabLabel' : 'tabLabel'} id='Users' onClick={handleTabClick}>Users</p>) : null}
                            </>
                        }
                        <p className='tabLabel' id='Logout' onClick={logOutClicked}>Logout</p>
                    </div>
                </div>
                <div className='dashBody' >
                    <div className='selectedTabBody' style={{ width: PageSelected === 'Briefs' || PageSelected === 'Projects' ? '100%' : '', margin: PageSelected === 'Briefs' || PageSelected === 'Projects' ? '0px' : '' }}>
                        {(PageSelected === 'Overview') ? <Overview /> : null}
                        {(PageSelected === 'Audit') ? <Audit /> : null}
                        {(PageSelected === 'Users') ? <Users /> : null}
                        {(PageSelected === 'Profile') ? <Profile /> : null}
                        {(PageSelected === 'Briefs') ? <Briefs /> : null}
                        {(PageSelected === 'Clients') ? <Clients /> : null}
                        {(PageSelected === 'Professionals') ? <Professionals /> : null}

                        {(PageSelected === 'Projects') ? <Projects /> : null}
                    </div>
                    <div className='credippleDashFooter'>
                        <p className='footerContent' onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'} onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}>T’s & C’s</p>
                        <p className='footerContent' onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'} onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}>Privacy</p>
                        <p className='footerContent' onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'} onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}>FAQ’S</p>
                        <p className='footerContent' onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'} onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}>CC.Credipple.2024</p>
                    </div>
                </div>
                {/* <div className='admindash-sidebar'>
                    <div className='user-details'>
                        <div className='profile-picture-container'>
                            <img src={userIcon} alt='User Profile' />
                        </div>
                        <div className='user-credentials-section'>
                            <p className='userName'>{store.user.firstName || ''} {store.user.lastName || ''}</p>
                            <p className='userEmail'>{store.user.email || ''}</p>
                        </div>
                    </div>
                    <hr className='hr' />
                    <div className='tab-section'>
                        <p className={PageSelected === 'Profile' ? 'selectedTab' : ''} id='Profile' onClick={handleTabClick}>Profile</p>
                        <p className={PageSelected === 'Users' ? 'selectedTab' : ''} id='Users' onClick={handleTabClick}>Users</p>
                        <p className={PageSelected === 'Clients' ? 'selectedTab' : ''} id='Clients' onClick={handleTabClick}>Clients</p>
                        <p className={PageSelected === 'Projects' ? 'selectedTab' : ''} id='Projects' onClick={handleTabClick}>Projects</p>
                    </div>
                </div>
                <div className='adminDash-body'>
                    <div className='body-content'>
                        {(PageSelected === 'Users') ? <Users /> : null}
                        {(PageSelected === 'Profile') ? <Profile /> : null}
                        {(PageSelected === 'Projects') ? <Projects /> : null}
                        {(PageSelected === 'Clients') ? <Clients /> : null}
                    </div>
                    <div className='footer-content'>
                        <div style={{ width: '60%', display: 'Flex', flexDirection: 'row', alignContent: 'center', justifyContent: 'space-around' }}>
                            <p style={{ cursor: 'pointer', textDecoration: 'none' }} onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'} onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}>T’s & C’s</p>
                            <p style={{ cursor: 'pointer', textDecoration: 'none' }} onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'} onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}>Privacy</p>
                            <p style={{ cursor: 'pointer', textDecoration: 'none' }} onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'} onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}>FAQ’S</p>
                        </div>
                        <div style={{ width: '40%', display: 'Flex', flexDirection: 'row', alignContent: 'center', justifyContent: 'center' }}>
                            <p style={{ cursor: 'pointer', textDecoration: 'none' }} onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'} onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}>CC.Credipple.2024</p>
                        </div>
                    </div>
                </div> */}
                {/* Logout Confirmation Popup */}
                {showLogoutPopup && (
                    <View className='logoutPopup'>
                        <div className='popupContent'>
                            <p>Are you sure you want to log out?</p>
                            <button onClick={confirmLogout}>Yes</button>
                            <button onClick={cancelLogout}>No</button>
                        </div>
                    </View>
                )}

            </View>
        )
    }
})

export default AdminDashboard;